(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
 class StickyHeader extends HTMLElement {
  constructor() {
    super();
    this.setHeaderHeight = this.setHeaderHeight.bind(this);
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
    this.headerIsAlwaysSticky =
      this.getAttribute('data-sticky-type') === 'always' ||
      this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};

    this.setHeaderHeight();

    this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    }

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearches = this.querySelectorAll('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  disconnectedCallback() {
    this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  isSearchOpen() {
    return (
      !!this.header.querySelector('details-modal details[open]') ||
      [...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)
    );
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    // Search open: freeze all hide/reveal logic, but keep tracking scroll position.
    if (this.isSearchOpen()) {
      this.currentScrollTop = scrollTop;
      return;
    }

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    if (this.isSearchOpen()) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    if (this.isSearchOpen()) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach((disclosure) => disclosure.close());
  }

  closeSearchModal() {
    this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
    this.searchModals.forEach((searchModal) => searchModal.close(false));
  }
}

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  /*
    Open desktop dropdowns and nested submenus on hover while
    preserving Dawn click/keyboard behavior.
  */
  const initHeaderHoverMenus = () => {
    const desktopQuery = window.matchMedia('(min-width: 990px)');
    const root = document.querySelector('.header__inline-menu');
    if (!root) return;

    const menuDetails = root.querySelectorAll('details');

    menuDetails.forEach((details) => {
      if (details.dataset.osHoverReady === 'true') return;
      details.dataset.osHoverReady = 'true';

      let closeTimer;
      const summary = details.querySelector(':scope > summary');

      const setExpanded = (expanded) => {
        if (summary) summary.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      };

      const closeSiblingMenus = () => {
        const parent = details.parentElement?.parentElement;
        if (!parent) return;

        parent.querySelectorAll(':scope > li > details[open]').forEach((sibling) => {
          if (sibling === details) return;
          sibling.removeAttribute('open');

          const siblingSummary = sibling.querySelector(':scope > summary');
          if (siblingSummary) siblingSummary.setAttribute('aria-expanded', 'false');

          sibling.querySelectorAll('details[open]').forEach((childDetails) => {
            childDetails.removeAttribute('open');
            const childSummary = childDetails.querySelector(':scope > summary');
            if (childSummary) childSummary.setAttribute('aria-expanded', 'false');
          });
        });
      };

      const openMenu = () => {
        if (!desktopQuery.matches) return;
        window.clearTimeout(closeTimer);
        closeSiblingMenus();
        details.setAttribute('open', '');
        setExpanded(true);
      };

      const closeMenu = () => {
        if (!desktopQuery.matches) return;
        window.clearTimeout(closeTimer);

        closeTimer = window.setTimeout(() => {
          if (!details.matches(':hover') && !details.contains(document.activeElement)) {
            details.removeAttribute('open');
            setExpanded(false);

            details.querySelectorAll('details[open]').forEach((childDetails) => {
              childDetails.removeAttribute('open');
              const childSummary = childDetails.querySelector(':scope > summary');
              if (childSummary) childSummary.setAttribute('aria-expanded', 'false');
            });
          }
        }, 140);
      };

      details.addEventListener('mouseenter', openMenu);
      details.addEventListener('mouseleave', closeMenu);
      details.addEventListener('focusin', () => {
        window.clearTimeout(closeTimer);
        openMenu();
      });
      details.addEventListener('focusout', closeMenu);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderHoverMenus, { once: true });
  } else {
    initHeaderHoverMenus();
  }

  document.addEventListener('shopify:section:load', initHeaderHoverMenus);


  /*
    Mobile drawer accordion fix:
    Dawn's menu-drawer component normally opens child menus as a new full-width panel.
    We keep the native <details> semantics but stop the child submenu from becoming
    a translated screen.
  */
  const initOceanMobileDrawer = () => {
    const drawer = document.querySelector('header-drawer #menu-drawer');
    if (!drawer || drawer.dataset.osAccordionReady === 'true') return;

    drawer.dataset.osAccordionReady = 'true';

    drawer.querySelectorAll('.menu-drawer__menu details').forEach((details) => {
      const summary = details.querySelector(':scope > summary');
      if (!summary) return;

      summary.addEventListener('click', () => {
        window.requestAnimationFrame(() => {
          const submenu = details.querySelector(':scope > .menu-drawer__submenu');
          if (submenu) {
            submenu.style.transform = 'none';
            submenu.style.visibility = 'visible';
          }
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOceanMobileDrawer, { once: true });
  } else {
    initOceanMobileDrawer();
  }

  document.addEventListener('shopify:section:load', initOceanMobileDrawer);

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
